import React from 'react';

const Loading = ({ size = 'md', text = '' }) => {
  const sizes = { 
    sm: 'w-4 h-4', 
    md: 'w-8 h-8', 
    lg: 'w-12 h-12' 
  };
  
  return (
    <div className="flex flex-col items-center justify-center p-8">
      <div className={`${sizes[size]} border-2 border-emerald-500/30 border-t-emerald-500 rounded-full animate-spin`} />
      {text && <p className="mt-3 text-slate-400 text-sm">{text}</p>}
    </div>
  );
};

export default Loading;
